<template>
  <div>
    <b-form @submit.prevent="updateGeoLine" @mouseover="geoLine.extraData.weight = 4" @mouseout="geoLine.extraData.weight = 2">
      <b-form-row>
        <b-form-group class="col-12">
          <label :for="'geofence-name-' + index" v-translate>Name <small class="text-danger">(required)</small></label>
          <b-form-input :id="'geofence-name-' + index" v-model="geoLine.name" type="text" required />
        </b-form-group>
        <b-form-group class="col-12">
          <label :for="'geofence-type-' + index" v-translate>Type <small class="text-danger">(required)</small></label>
          <b-form-select :id="'geofence-type-' + index" v-model="geoLine.geo_type_id" :options="geoTypesSelect.filter(x => x.type === geoLine.originalPath.type.toLowerCase())" v-if="geoTypesSelect.length > 0" required>
            <template #first>
              <option :value="null">Select the Type</option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-form-row>
      <b-button size="sm" :variant="geoLineHasChanges ? 'secondary' : 'dark'" :disabled="!geoLineHasChanges" type="submit">
        <b-spinner small v-if="updating"></b-spinner>
        <translate>Save Changes</translate>
      </b-button>
      <b-button size="sm" @click.prevent="emitCenter" :title="$gettext('Center in Map')" v-b-tooltip.hover><font-awesome-icon icon="crosshairs" /></b-button>
      <b-button size="sm" variant="dark" @click="geoLine.extraData.visible = !geoLine.extraData.visible" :title="!geoLine.extraData.visible ? $gettext('Show Element') : $gettext('Hide Element')" v-b-tooltip.hover>
        <font-awesome-icon :icon="['far', 'eye']" v-show="!geoLine.extraData.visible" />
        <font-awesome-icon :icon="['far', 'eye-slash']" v-show="geoLine.extraData.visible" />
      </b-button>
      <b-button size="sm" variant="danger" @click="removeGeoLine" :title="$gettext('Remove Relation')" v-b-tooltip.hover>
        <font-awesome-icon icon="unlink" />
      </b-button>
    </b-form>
  </div>
</template>

<script>
import {
  GeofenceService,
  GeoLineService
} from '@/services/api'

export default {
  emits: ['center', 'remove', 'updated'],
  name: 'GeoLineForm',
  props: {
    geoLine: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      default: Math.random()
    }
  },
  data() {
    return {
      geoTypesSelect: [],
      hash: null,
      updating: false
    }
  },
  computed: {
    geoLineHasChanges() {
      const geoLineHash = { ...this.geoLine }
      delete geoLineHash.extraData
      return JSON.stringify(geoLineHash) !== this.hash
    }
  },
  watch: {
    'geoLine.geo_type_id': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) {
          this.geoLine.geo_type = this.geoTypes.find(x => x.id === newValue)
        } else {
          this.geoLine.geo_type = {
            name: ''
          }
        }
      }
    }
  },
  created () {
    this.geoTypesSelect = this.geoTypes.map(x => {
      return {
        text: this.toTitleCase(x.name),
        value: x.id,
        type: x.type
      }
    })
  },
  mounted () {
    const geoLineHash = { ...this.geoLine }
    delete geoLineHash.extraData
    this.hash = JSON.stringify({ ...geoLineHash })
    if (this.geoLine.id && this.geoLine.adding) {
      GeofenceService.addGeoline(this.geoLine.parent, this.geoLine.id)
        .then(() => {
          this.$nextTick(() => {
            this.$emit('updated', true)
            const geoLineHash = { ...this.geoLine }
            delete geoLineHash.extraData
            this.hash = JSON.stringify({ ...geoLineHash })
          })
        })
    }
  },
  methods: {
    updateGeoLine() {
      this.updating = true
      if (this.geoLine.id) {
        GeoLineService.update(this.geoLine.id, this.geoLine)
          .then(() => {
            this.$nextTick(() => {
              this.$emit('updated', true)
              this.updating = false
            })
          })
      } else {
        GeoLineService.create(this.geoLine)
          .then(response => {
            GeofenceService.addGeoline(this.geoLine.parent, response.body.id)
              .then(() => {
                this.$nextTick(() => {
                  this.$emit('updated', true)
                  this.updating = false
                })
              })
          })
      }
    },
    removeGeoLine() {
      if (confirm(this.$gettext('Are you sure you want to REMOVE THIS RELATION?'))) {
        if (this.geoLine.id) {
          GeofenceService.removeGeoline(this.geoLine.parent, this.geoLine.id)
            .then(() => {
              this.$nextTick(() => {
                this.$emit('updated', true)
              })
            })
        } else {
          this.$emit('remove', true)
        }
      }
    },
    emitCenter($event) {
      this.$emit('center', 'line', this.geoLine.path)
    }
  }
}
</script>
